import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux';
import {Store, Persistor} from './store';
import {PersistGate} from 'redux-persist/es/integration/react';
import { initAppInsights, setupGlobalErrorHandlers, setupTelemetryFlushListeners, setupChatbotTracking } from './util/appInsights';
import ErrorBoundary from './components/error-boundary';

// Inicialização da telemetria e handlers globais antes do render
initAppInsights();
setupGlobalErrorHandlers();
setupTelemetryFlushListeners();
setupChatbotTracking();

ReactDOM.render(
  <ErrorBoundary>
    <Provider store={Store}>
      <PersistGate persistor={Persistor}>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </PersistGate>
    </Provider>
  </ErrorBoundary>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
